import React from 'react';

function Footer() {
  return (
    <footer className="clean-footer crev ">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="logo icon-img-60 md-mb80">
              <img src="/assets/imgs/logo-light.png" alt="" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Contact</h6>
              <h6 className="p-color fw-400">
                175 SW 7th Street, Suite 2410<br />
                Miami, Florida 33130
              </h6>
              <h6 className="mt-30 mb-15">
                <a href="mailto:accounts@profilemgmt.co">accounts@profilemgmt.co</a>
              </h6>
              {/* <a href="#0" className="underline">
                <span className="fz-22 main-color">+2 456 (343) 24 45</span>
              </a> */}
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">More Links</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <a href="https://app.profilemgmt.com/sign-in">Model Login</a>
                </li>
   
                <li className="mb-15">
                  <a href="/contact">Contact Us</a>
                </li>
                <li className="mb-15">
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li className="mb-15">
                  <a href="/terms-and-conditions">Terms &amp; Conditions</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              {/* <h6 className="sub-title mb-30">Newsletter</h6>
              <div className="form-group mb-40">
                <input type="text" name="subscrib" placeholder="Your Email" />
                <button>
                  <span className="ti-location-arrow"></span>
                </button>
              </div> */}
      
              <ul className="rest social-icon d-flex align-items-center">
                {/* <li className="hover-this cursor-pointer">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li> */}
                <li className=" ml-10">
                  <a href="https://x.com/ProfileMgmt" target='_blank' >
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li className=" ml-10">
                  <a href="https://www.instagram.com/profilemgmt/" target='_blank' >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © 2024 Profile Management 
            </p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
